import $ from 'jquery';
import abp from 'abp';
import CKEDITOR from 'ckeditor';

export default function() {
}





// WEBPACK FOOTER //
// ./App/config/ck-editor-templates.js